import { addDays, differenceInDays, endOfDay, startOfDay } from 'date-fns'

import { formatDatetime } from 'utils/datetime'

export const findDatesBetween = (endDate: Date, startDate: Date) => {
  const difference = differenceInDays(endOfDay(endDate), startOfDay(startDate))
  const datesBetween: Date[] = []

  for (let i = 0; i <= difference; i++) {
    datesBetween.push(addDays(startDate, i))
  }

  return datesBetween
}

export const prepMarkedDates = (dates: Date[]) => dates.map((i) => formatDatetime(i, 'MM/dd/yyyy'))
